export default {"src":"/_next/static/media/enterprise.1647aa87.svg","height":36,"width":36};